<template>
    <div id="app">
        <!-- <img alt="Vue logo" src="./assets/logo.png">
        <HelloWorld msg="Welcome to Your Vue.js App"/>-->
        <router-view></router-view>
    </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'

export default {
    name: "App",
    components: {
        //HelloWorld
    },
    mounted(){
        
    }
};
</script>

<style>
body {
    background-color: #eee;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0;
    max-width: 750px;
    margin: auto;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
}
</style>
